import TextField from "@mui/material/TextField";
import { Autocomplete as MUIAutocomplete } from "@mui/material";

export function Autocomplete({
  label,
  options,
  sx,
  variant = "standard",
  optionLabel = "label",
  ...rest
}) {
  return (
    <MUIAutocomplete
      disablePortal
      options={options}
      sx={{ mb: ".6em", ...sx }}
      filterSelectedOptions
      //   getOptionSelected={(option, value) => option.title === value.title}
      getOptionLabel={(option) => option[optionLabel] || null}
      renderInput={(params) => (
        <TextField {...params} label={label} variant={variant} size="small" />
      )}
      {...rest}
    />
  );
}
